import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * Hace scroll automáticamente al inicio de la página cuando cambia la ruta.
 * 
 * Buenas prácticas de UX:
 * - Al navegar a una página diferente → scroll al inicio (top)
 * - Mejora la experiencia del usuario evitando que vea el medio de la nueva página
 * - Comportamiento esperado similar a navegación web tradicional
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll al inicio cada vez que cambia la ruta
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Este componente no renderiza nada
}

export default ScrollToTop;
